import { Component } from 'react';
import { withRouter } from 'react-router-dom'
import NProgress from 'nprogress'

import Train from '../../services/train.js';
import Notification from '../../services/Notification.js';
import User from '../../services/User.js';

class TwitterCredentials extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {}

    let queryParams = new URLSearchParams(props.location.search);

    let oauth_token = queryParams.get('oauth_token');
    let oauth_verifier = queryParams.get('oauth_verifier');

    this.connectToTwitter({oauth_token, oauth_verifier});
  }

  connectToTwitter({oauth_token, oauth_verifier}) {
    NProgress.start();
    Train.authorizeTwitter({oauth_token, oauth_verifier})
    .then((data) => {
      NProgress.done();
      Notification.show('Accounts have been connected', 'success');
      this.props.history.push(`/users/${User.getId()}/settings`);
    })
    .catch((error) => {
      NProgress.done();
      Notification.show('Error connecting to Twitter', 'error');
      this.props.history.push(`/users/${User.getId()}/settings`);
    });
  }

  render() {
    return null;
  }

}

export default withRouter(TwitterCredentials);



// WEBPACK FOOTER //
// ./src/js/components/twitter/TwitterCredentials.jsx